import type { ReactNode } from 'react';

export const symbol_desktop_portrait: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M470-240h140q12.75 0 21.38-8.63Q640-257.25 640-270v-300q0-12.75-8.62-21.38Q622.75-600 610-600H470q-12.75 0-21.37 8.62Q440-582.75 440-570v300q0 12.75 8.63 21.37Q457.25-240 470-240ZM354-366q6-6 6-14v-280q0-8 6-14t14-6h100q8 0 14-6t6-14q0-8-6-14t-14-6H380q-24.75 0-42.37 17.62Q320-684.75 320-660v280q0 8 6 14t14 6q8 0 14-6Zm446 226q0 24-18 42t-42 18H220q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h520q24 0 42 18t18 42v680Zm-60 0v-680H220v680h520Zm0-680H220h520Z"
		/>
	</svg>
);
